import { render, staticRenderFns } from "./ProductTypeList.vue?vue&type=template&id=ee5c70c0&scoped=true"
import script from "./ProductTypeList.vue?vue&type=script&lang=js"
export * from "./ProductTypeList.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeList.vue?vue&type=style&index=0&id=ee5c70c0&prod&lang=scss"
import style1 from "./ProductTypeList.vue?vue&type=style&index=1&id=ee5c70c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5c70c0",
  null
  
)

export default component.exports